// TODO TypeScript this
/* istanbul ignore file */

import _ from 'lodash'
import moment from 'moment'
import { SORT_ORDERS, SORT_TYPES, SORT_TYPES_DESC_OVERRIDE } from '../constants'
import { getStateCode } from '../useListingsSearch/utils'

export const productTypes = {
  resi_bo_v2: 'bank-owned',
  resi_ft: 'foreclosures',
  resi_new_foreclosed: 'newly-foreclosed',
  resi_ip: 'rentals',
  // TODO: product type or asset type ?
  resi_ss: 'short-sales',
  // TODO: product type or asset type ?
  resi_ps: 'private-seller',
}

/**
 * Usage: New asset type (product type) filter route
 * - new route has "_at" added after resi_ft & resi_new_foreclosed
 * - refer to toolkit-adc/src/components/header/constants/route
 */
export const assetTypeFilterRoute = {
  resi_bo_v2: 'bank-owned',
  resi_ft: 'foreclosures_at',
  resi_new_foreclosed: 'newly-foreclosed_at',
  resi_ip: 'rentals',
  resi_ss: 'short-sales_at',
  // TODO: Private seller ?
}

export const propertyTypes = {
  resi_sfr: 'single-family',
  resi_mfr: 'multi-family',
  resi_condo: 'condos-townhouses',
  resi_land: 'land',
}

const productDisplayTypes = {
  resi_bo_v2: 'Bank Owned',
  resi_ft: 'Foreclosures',
  resi_ip: 'Rentals',
  resi_ss: 'Short Sales',
}

const propertyDisplayTypes = {
  resi_sfr: 'Single Family',
  resi_mfr: 'Multi-family',
  resi_condo: 'Condo/Townhome',
  resi_land: 'Land',
}

const listingTypes = {
  active: 'Active',
  pending: 'Pending',
  closed: 'Sold',
  canceled: 'Canceled',
}

const assetEventTypes = {
  online: 'Online',
  in_person: 'In Person',
}

const mainDisplay = new Set([
  'State',
  'City',
  'County',
  'Zip',
  'Beds',
  'Baths',
  'Sqft Range',
])
const propertyAndAssetTypesSet = new Set(['Property Type', 'Asset Type'])
const listAndAuctionTypesSet = new Set(['Listing Type', 'Auction Type'])
const showOnlySet = new Set([
  'Vacant',
  'Financing Available',
  'Interior Access Available',
  'Reserve Disclosed',
  'Hide Ending Soon',
  'Broker Co-op',
  "No Buyer's Premium",
])
/*
 * Location Parameters
 */
export const showOnlyFields = [
  'y_ica',
  'y_fa',
  'y_ia',
  'y_sr',
  'y_bc',
  'y_nbp',
  'y_hes',
  // this was here before but it's not in srp showOnlyFields code
  'y_cs',
  // this was not here before but it is in srp showOnlyFields
  'y_rr',
  'y_ps',
  'y_global',
  'map_vt',
]

export const arrayToApiProductType = value => {
  const apiProductTypes = []
  // This is used to deal with the old search url pass 'bank-owned' only
  // We need the `newly-foreclosed` send to API

  if (value[0] === 'bank-owned' && value.length === 1) {
    const apiProductTypes = Object.entries(productTypes)
      .filter(([_, uiProductType]) =>
        ['bank-owned', 'newly-foreclosed'].includes(uiProductType)
      )
      .map(productType => productType[0])

    return apiProductTypes.join(',')
  }

  value.forEach(type => {
    const productTypeEntry = Object.entries(productTypes).find(
      ([_, uiProductType]) => uiProductType === type
    )

    if (productTypeEntry) {
      apiProductTypes.push(productTypeEntry[0])
    }
  })
  return apiProductTypes.join(',')
}

/**
 *
 * @param {*} sortType
 * @param {*} sortOrder
 * This function will allow to add to sort override desc to handle special cases like starting_bid/starting_bid_desc
 * In this kind of cases doesn't work to use an empty space to separate, you have a special value to be used from
 * api side. From now on you may only need to add it to SORT_TYPES_DESC_OVERRIDE and will be handled
 */
const getSortOrder = (sortType, sortOrder) => {
  return SORT_TYPES_DESC_OVERRIDE[sortType]
    ? SORT_TYPES_DESC_OVERRIDE[sortType]
    : `${sortType} ${sortOrder}`
}

export const stringToSortObject = value => {
  const sort = value.split(',')[0].split(' ')
  let sortType = SORT_TYPES.default
  let sortOrder = SORT_ORDERS.asc
  if (sort[0] === SORT_TYPES.defaultDesc) {
    return {
      type: SORT_TYPES.default,
      order: SORT_ORDERS.desc,
    }
  }

  /**
   * Added this escape hatch to handle special sort cases like starting_bid/starting_bid_desc
   * where the default way using an empty space doesn't work from api side
   *
   * else continue with regular flow
   */
  const overrideSortKey = _.findKey(
    SORT_TYPES_DESC_OVERRIDE,
    value => value === sort[0]
  )
  if (overrideSortKey) {
    sortOrder = SORT_ORDERS.desc
    sortType = overrideSortKey
  } else {
    for (const item in SORT_TYPES) {
      if (SORT_TYPES[item] === sort[0]) {
        sortType = SORT_TYPES[item]
      }
    }
    if (sort[1]) {
      for (const item in SORT_ORDERS) {
        if (SORT_ORDERS[item] === sort[1]) {
          sortOrder = SORT_ORDERS[item]
        }
      }
    }
  }

  return {
    type: sortType,
    order: sortOrder,
  }
}

export const sortObjectToString = sort => {
  const addSortOrder = sort.order === SORT_ORDERS.desc
  if (sort.type === SORT_TYPES.default && addSortOrder)
    return SORT_TYPES.defaultDesc
  const preSort = addSortOrder ? getSortOrder(sort.type, sort.order) : sort.type
  // 'resi_sort_v2' (default) must always be in the sort
  const resiSortV2 =
    sort.type === SORT_TYPES.default
      ? preSort
      : `${preSort},${SORT_TYPES.default}`
  return resiSortV2
}

export const stringToSqftObject = value => {
  const sqftObject = {
    min: null,
    max: null,
  }
  const sqftArray = value
    .split('_')
    .map(d => (d === 'any' ? null : parseInt(d)))
  if (sqftArray[0]) sqftObject.min = sqftArray[0]
  if (sqftArray[1]) sqftObject.max = sqftArray[1]
  return sqftObject
}

const areBoundsSetSqft = (min, max) => min > 0 && max > 0

const isReveresedRangeSqft = (min, max) => min > max

export const sqftObjectToApi = value => {
  const sqftApiObject = {}

  // sepecial case when user sets both inputs but reverses the range
  // min and max values will be reversed only for the API; no changes on url
  if (
    areBoundsSetSqft(value.min, value.max) &&
    isReveresedRangeSqft(value.min, value.max)
  ) {
    return {
      sqft_min: `${value.max}`,
      sqft_max: `${value.min}`,
    }
  }

  if (value.min) sqftApiObject.sqft_min = `${value.min}`
  if (value.max) sqftApiObject.sqft_max = `${value.max}`
  return sqftApiObject
}

export const arrayToApiPropertyType = value => {
  const apiPropertyTypes = []
  value.forEach(type => {
    const propertyType = Object.entries(propertyTypes).find(
      ([_, uiPropertyType]) => uiPropertyType === type
    )
    if (propertyType) apiPropertyTypes.push(propertyType[0])
  })

  return apiPropertyTypes.join(',')
}

export const stringToArrayFloat = value =>
  value.split(',').map(o => parseFloat(o))

export const stringToArrayAddingSpaces = value =>
  value
    .replace(/-/g, ' ')
    .replace(/\+/g, '-')
    .split(',')
    .map(o => o.replace(/\w+/g, _.capitalize))

export const arrayToStringRemovingSpaces = value =>
  value.join().replace(/-/g, '+').replace(/ /g, '-')

export const stringToArray = value => value.split(',')

export const addUrlKey = (value, filter) => {
  if (showOnlyFields.includes(filter.url)) {
    return filter.url
  } else if (filter.api === 'property_state') {
    return value
  } else if (filter.api === 'property_county') {
    return `${value}-${filter.url}` // dash needed for county
  } else {
    return `${value}_${filter.url}`
  }
}

export const stateFeToApi = (state = []) => {
  if (state[0]) {
    return getStateCode(state[0])
  }
  return ''
}

export const stringSpaceToDash = value =>
  value.replace(/-/g, '+').split(' ').join('-')

export const auctionFormatConverterUpperCase = value => {
  const auctionArr = value.split(',')
  const auctionLabels = []
  auctionArr.forEach(label => {
    const auctionLabel = assetEventTypes[label]
    if (auctionLabel) auctionLabels.push(auctionLabel)
  })
  return _.join(auctionLabels, ', ')
}

export const booleanStringToBoolean = value => _.toLower(value) === 'y'

export const noBuyerPremiumConverter = value => _.toLower(value) === 'n'

export const propertyTypeConverter = value => {
  const valueArr = value.split(',')
  const apiPropertyTypes = []
  valueArr.forEach(type => {
    const propertyType = propertyTypes[type]
    if (propertyType) apiPropertyTypes.push(propertyType)
  })
  return apiPropertyTypes.join(',')
}

export const propertyTypeConverterWithSpace = value => {
  const valueArr = value.split(',')
  const apiPropertyTypes = []
  valueArr.forEach(type => {
    const propertyType = propertyDisplayTypes[type]
    if (propertyType) apiPropertyTypes.push(propertyType)
  })
  return apiPropertyTypes.join(', ')
}

export const assetTypeConverter = value => {
  const valueArr = value.split(',')
  const apiProductTypes = []
  valueArr.forEach(type => {
    const productType = productTypes[type]
    if (productType) apiProductTypes.push(productType)
  })
  return apiProductTypes.join(',')
}

export const assetTypeConverterWithSpace = value => {
  const valueArr = value.split(',')
  const apiProductTypes = []
  valueArr.forEach(type => {
    const productType = productDisplayTypes[type]
    if (productType) apiProductTypes.push(productType)
  })
  return apiProductTypes.join(', ')
}

export const listingTypeToLabels = value => {
  const valueArr = value.split(',')
  const listingTypelabels = []
  valueArr.forEach((type, i) => {
    const listingType =
      valueArr.length > 2 && i === valueArr.length - 1
        ? `or ${listingTypes[type]}`
        : listingTypes[type]
    if (listingType) listingTypelabels.push(listingType)
  })
  return listingTypelabels.join(', ')
}

export const dateStringToUrl = value => {
  const isDisplay =
    !!value && moment(value).isSame(moment().add(5, 'days'), 'day')
  return isDisplay && `${value}_any`
}

export const sqftObjectToString = value => {
  if (!(value.min || value.max)) return
  return `${value.min ? value.min : 'any'}_${value.max ? value.max : 'any'}`
}

export const sqftToLabel = value => {
  if (!(value.min || value.max)) return
  return `${value.min ? value.min : 'Any'} to ${value.max ? value.max : 'Any'}`
}

export const checkOccupancy = value => _.toLower(value) === 'vacant'

export const numberWithPlus = value => value && `${value}+`

export const categorizeLabels = (labels, inputLabel, paramValue) => {
  if (mainDisplay.has(inputLabel)) {
    labels.mainDisplay.push([inputLabel, paramValue])
  } else if (propertyAndAssetTypesSet.has(inputLabel)) {
    labels.propertyAndAssetTypes.push([inputLabel, paramValue])
  } else if (listAndAuctionTypesSet.has(inputLabel)) {
    labels.listAndAuctionTypes.push([inputLabel, paramValue])
  } else if (showOnlySet.has(inputLabel)) {
    labels.showOnlyFields.push([inputLabel, paramValue])
  }
}

/**
 * Convert asset type search param to filter route part
 */
export const assetTypeRouteConverter = value => {
  const valueArr = value.split(',')
  const apiProductTypes = []
  valueArr.forEach(type => {
    const productType = assetTypeFilterRoute[type]
    if (productType) apiProductTypes.push(productType)
  })
  return apiProductTypes.join(',')
}
